import React, { useEffect, useMemo, useState } from 'react'
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from '../../components'
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from '../../components/NextUITable'
import { usePost } from '../../api/reactQueryCustomHooks'
import { apiRoute, GetLoginCredentialDb, linksUrl } from '../../constants/enum'
import { faEdit, faPlus, faReceipt, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import { Button, Modal, ModalBody, ModalHeader, ModalContent, useDisclosure } from '@nextui-org/react'
import { useDispatch, useSelector } from 'react-redux'
import { resetDetailParams, resetRecVouDetail, setDetailParams, setIsRediOutstanding, setNewEntryMode, setVouReportDetail } from '../../state/receiveEntrySlice'
import ConfirmBox from '../../components/ConfirmBox'
import { toast } from 'react-toastify'
import { calculateTotal } from '../../Utility/utility'
import ReportViewer from '../report/ReportViewer'
import { enum_Report_Type } from '../report/ReportUtility'
import { resetReportDetail } from '../../state/invoiceSlice'
import { resetPayVoutDetail } from '../../state/paymentEntrySlice'

const ReceiveEntryMaster = () => {
    const {
        isOpen: isOpenModel,
        onOpen: onOpenModel,
        onOpenChange: onOpenModelChange
    } = useDisclosure()

    const { token, user } = useSelector((state) => state.auth)
    const { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [itemToDelete, setItemToDelete] = useState("")
    const INITIAL_VISIBLE_COLUMNS = ["actions", "BookName", "PartyName", "Vou_No", "Remark","Chq_Amt", "Chq_Date"]
    // const [data, setData] = useState([])



    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
        dispatch(resetDetailParams())
        dispatch(setIsRediOutstanding(false))
    }, [])

    const { isPending, isError,
        //  data: EntryData = [],
        data = [],
        mutate: filterData } = usePost({
            url: apiRoute.transaction.receiveEntry.fetch,
            queryKey: "Receive Entry Data"
        })
    const exportColumns = [
        {
            name: "Book Name",
            uid: "BookName",
        },
        {
            name: "Party Name",
            uid: "PartyName",
        },
        {
            name: "Vou No",
            uid: "Vou_No",
        },
        {
            name: "Narration",
            uid: "Remark",
        },
        {
            name: "Rec.amt",
            uid: "Chq_Amt",
        },
        {
            name: "Trans.Date",
            uid: "Chq_Date",
            type:COLUMN_TYPE.date
        }
    ]
    const totalRecAmt = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Chq_Amt",
            }),
        [data])


    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center
        },
        {
            name: "Book Name",
            uid: "BookName",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Party Name",
            uid: "PartyName",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },

        {
            name: "Vou No",
            uid: "Vou_No",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Narration",
            uid: "Remark",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            isLineBreak:true
        },
        {
            name: "Rec.Amt",
            uid: "Chq_Amt",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalRecAmt,
            },
        },
        {
            name: "Trans.Date",
            uid: "Chq_Date",
            align: COLUMN_ALIGN_TYPE.center,
            type: COLUMN_TYPE.date,
            sortable: true
        },
    ]



    const funLoadData = () => {
        filterData({
            data: {
                comp_code: compCode.join(","),
                vou_type: "R",
                trans_id: ""
            }
        })
    }

    // const handleDataChange = ({ data, isFilter }) => {
    //     if (isFilter)
    //         setData(data)
    //     else
    //         setData(EntryData)
    // }

    // useEffect(() => {
    //     setData(EntryData)
    // }, [EntryData])


    useEffect(() => {
        funLoadData()
    }, [])

    const reportModel = () => {
        return (
            <Modal
                isOpen={isOpenModel}
                onOpenChange={onOpenModelChange}
                size="md">
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-row gap-1">
                                Voucher
                            </ModalHeader>
                            <ModalBody>
                                <div className="flex flex-col">
                                    <ReportViewer props_ReportType={enum_Report_Type.RecVoucher} />
                                </div>
                            </ModalBody>
                        </>

                    )}
                </ModalContent>
            </Modal>
        )
    }

    let downloadDataFooter = {
        BookName: "", PartyName: "", Vou_No: "",Remark:"", Chq_Amt: "Total:" + totalRecAmt,
        Chq_Date: " ",
    }
    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
            onClick: (row) => {
                let obj = {
                    compcode: row.COMPCODE,
                    transactionid: row.TransactionId,
                    pacid: row.Pac_Id,
                    voutype: row.Vou_Type,
                }

                dispatch(setDetailParams(obj))
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.transaction.receiveEntry.createEntry)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
            onClick: (row) => {
                setItemToDelete({ transaction_id: row.TransactionId, comp_code: row.COMPCODE, vou_type: row.Vou_Type })
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon color="#FFFFFF" icon={faReceipt} />,
            onClick: (row) => {
                dispatch(resetReportDetail())
                dispatch(resetPayVoutDetail())
                dispatch(resetRecVouDetail())
                dispatch(setVouReportDetail(row))
                onOpenModel()
            },
            label:"Print",
            color: "bg-sky-600",
            type: ROW_ACTION_BTN_TYPE.button,
        },

    ]
    const onSuccessDelete = (data) => {
        setItemToDelete("")
        funLoadData();
        toast.success("Entry Deleted",
            { position: "top-center" })

    }
    const { mutate: FnDeleteEntry } = usePost({
        url: apiRoute.transaction.receiveEntry.deleteEntry,
        queryKey: "DeleteReceiveEntry",
        onSuccessTasks: onSuccessDelete,

    })

    const handleConfirmBox = (data) => {
        if (data) {
            FnDeleteEntry({
                data: {
                    comp_code: itemToDelete.comp_code,
                    transaction_id: itemToDelete.transaction_id,
                    vou_type: itemToDelete.vou_type
                }
            })
        }
    }

    const handleAddNew = () => {
        dispatch(resetDetailParams())
        navigate(linksUrl.transaction.receiveEntry.createEntry)
    }
    if (isPending) {
        return <LoadingCard />
    }
    if (isError) {
        return <ErrorCard />
    }
    return (
        <div>
            {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}
            <MainContainer pageName='Receive Entries' breadcrumbs={["Transaction", "Receive Entry"]} >
                <div className="" style={{ textAlign: "right" }}>
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                {reportModel()}
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={data}
                    // handleDataChange={handleDataChange}
                    exportColumns={exportColumns}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    downloadDataFooter={downloadDataFooter}
                    showAdvanceFilter={false}
                    
                    downloadFileName='ReceiveEntry-list'
                    id="TransactionId"
                >
                </NextUITable>
            </MainContainer>
        </div>
    )
}

export default ReceiveEntryMaster